import { default as indexAL0H4a1DGpMeta } from "/data/business/pages/goodsdetail/index.vue?macro=true";
import { default as _91commodityId_93auEQJV7ainMeta } from "/data/business/pages/goodsdetailisr/[commodityId].vue?macro=true";
import { default as indexMAsKn4k8KKMeta } from "/data/business/pages/goodslist/index.vue?macro=true";
import { default as _91tagId_93_45_91tag2_93yVtbGK1SUzMeta } from "/data/business/pages/goodslistisr/index/[tagId]-[tag2].vue?macro=true";
import { default as index2TMeMRWFTBMeta } from "/data/business/pages/goodslistisr/index.vue?macro=true";
import { default as index5IeaENNUhLMeta } from "/data/business/pages/goodsmain/index.vue?macro=true";
import { default as indexARey39wRLjMeta } from "/data/business/pages/goodssearch/index.vue?macro=true";
import { default as index7Zmbak2POYMeta } from "/data/business/pages/index.vue?macro=true";
export default [
  {
    name: "goodsdetail",
    path: "/goodsdetail",
    component: () => import("/data/business/pages/goodsdetail/index.vue")
  },
  {
    name: "goodsdetailisr-commodityId",
    path: "/goodsdetailisr/:commodityId()",
    component: () => import("/data/business/pages/goodsdetailisr/[commodityId].vue")
  },
  {
    name: "goodslist",
    path: "/goodslist",
    meta: indexMAsKn4k8KKMeta || {},
    component: () => import("/data/business/pages/goodslist/index.vue")
  },
  {
    name: "Goodslist",
    path: "/goodslistisr",
    meta: index2TMeMRWFTBMeta || {},
    component: () => import("/data/business/pages/goodslistisr/index.vue"),
    children: [
  {
    name: "goodslistisr-index-tagId-tag2",
    path: ":tagId()-:tag2()",
    component: () => import("/data/business/pages/goodslistisr/index/[tagId]-[tag2].vue")
  }
]
  },
  {
    name: "goodsmain",
    path: "/goodsmain",
    component: () => import("/data/business/pages/goodsmain/index.vue")
  },
  {
    name: "goodssearch",
    path: "/goodssearch",
    meta: indexARey39wRLjMeta || {},
    component: () => import("/data/business/pages/goodssearch/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/data/business/pages/index.vue")
  }
]